module.exports = __webpack_public_path__ + "static/DSC_9370-80232ead51cf55e790f4555c8383a81a.jpg";